"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalProvider = void 0;
const react_1 = __importStar(require("react"));
const ModalContext_1 = require("./ModalContext");
const ModalRoot_1 = require("./ModalRoot");
/**
 * Modal Provider
 *
 * Provides modal context and renders ModalRoot.
 */
exports.ModalProvider = ({ children }) => {
    const [modals, setModals] = react_1.useState({});
    const showModal = react_1.useCallback((key, modal) => setModals(modals => (Object.assign(Object.assign({}, modals), { [key]: modal }))), []);
    const hideModal = react_1.useCallback((key) => setModals(modals => {
        const newModals = Object.assign({}, modals);
        delete newModals[key];
        return newModals;
    }), []);
    const contextValue = react_1.useMemo(() => ({ showModal, hideModal }), []);
    return (react_1.default.createElement(ModalContext_1.ModalContext.Provider, { value: contextValue },
        react_1.default.createElement(react_1.default.Fragment, null,
            children,
            react_1.default.createElement(ModalRoot_1.ModalRoot, { modals: modals }))));
};
